import { Component, inject } from '@angular/core';
import { PushPipe } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { PlanLevel } from '@ninety/platform/models/billing/plan-level';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import {
  selectFreePlanNotificationDismissed,
  selectIsFreemiumPlan,
} from '@ninety/platform/state/app-global/billing/billing-state.selectors';
import { TerraModule } from '@ninety/terra';

@Component({
  selector: 'ninety-billing-notification-banner',
  templateUrl: './billing-notification-banner.component.html',
  styleUrls: ['./billing-notification-banner.component.scss'],
  standalone: true,
  imports: [PushPipe, TerraModule],
})
export class BillingNotificationBannerComponent {
  private readonly store = inject(Store);

  protected readonly PlanName = PlanLevel;

  protected readonly isFreePlan$ = this.store.select(selectIsFreemiumPlan);
  protected readonly freePlanNotificationDismissed$ = this.store.select(selectFreePlanNotificationDismissed);

  learnMore() {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
  close() {
    this.store.dispatch(BillingStateActions.dismissFreePlanNotification());
  }
}
